import React from 'react';
import PropTypes from 'prop-types';

import FileTile from './FileTile';

import { FILE_TYPE } from './fileTile.constants';

function FileTileView({
  files = [],
  onClick = null,
  canDownload = false,
  onDelete = null,
  titleAsTooltip = false,
  dimensions = 64,
  containerStyle = {},
  shouldImageCoverContainer = false,
  externalTemplateId = null,
}) {
  return (
    files.map((file, index) => (
      <FileTile
        key={file.id}
        file={file}
        onClick={onClick ? () => onClick(index, file) : undefined}
        canDownload={canDownload}
        onDelete={onDelete ? () => onDelete(index) : undefined}
        titleAsTooltip={titleAsTooltip}
        dimensions={dimensions}
        containerStyle={containerStyle}
        shouldImageCoverContainer={shouldImageCoverContainer}
        externalTemplateId={externalTemplateId}
      />
    ))
  );
}

FileTileView.propTypes = {
  files: PropTypes.arrayOf(FILE_TYPE).isRequired,
  onClick: PropTypes.func,
  canDownload: PropTypes.bool,
  onDelete: PropTypes.func,
  titleAsTooltip: PropTypes.bool,
  dimensions: PropTypes.number,
  containerStyle: PropTypes.shape({}),
  externalTemplateId: PropTypes.string,
};

FileTileView.defaultProps = {
  titleAsTooltip: false,
  dimensions: 64,
  containerStyle: {},
};

export default FileTileView;
